import { useMemo } from 'react';

import { useProducts } from '../../ProductSelect';
import { useInviteeListStateContext } from '../../InviteeList';
import { type InvitePeopleData } from '../../../types';

export const useInvitePeopleData = (): InvitePeopleData => {
	const { groups, users, teams } = useInviteeListStateContext();
	const { selectedProducts, inviteCapabilities, hasPreselectedTwc } = useProducts();
	const { userPickerOptions: inviteeListOptions } = useInviteeListStateContext();

	return useMemo(
		() => ({
			groups,
			inviteCapabilities,
			inviteeListOptions,
			selectedProducts,
			users,
			teams,
			hasPreselectedTwc,
		}),
		[
			groups,
			inviteCapabilities,
			inviteeListOptions,
			selectedProducts,
			users,
			teams,
			hasPreselectedTwc,
		],
	);
};
